import { render, staticRenderFns } from "./stockproduct-edit.vue?vue&type=template&id=7147738a"
import script from "./stockproduct-edit.vue?vue&type=script&lang=ts"
export * from "./stockproduct-edit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports